<template>
  <div class="plk_configuration">
    <form @submit.prevent="save">
      <div v-for="(field, index) in fields" :key="index">
        <component @changeValue="changeValue(field.field, $event)" v-if="getInstance(field.type)" v-bind:is="getInstance(field.type)" :plkparams="field.plkparams" :default="defaultValues[field.field] || field.default"></component>
      </div>
      <textarea v-if="!fields.length" v-model="codestr" class="u-full-width" required></textarea>
      <button type="submit" class="mt-2 button pull-right">{{$t('configuration.save')}}</button>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { addValueInKey, getHashKeyValue } from '@/plugins/object'
import { TYPE_INTERNAL_OBJECT, TYPE_EXTERNAL_OBJECT } from '@/services/component'
import i18n from './i18n'
export default {
  name: 'configuration',
  props: {
    initValue: {
      type: Object,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      package: {},
      instances: {},
      defaultValues: {},
      model: {},
      codestr: ''
    }
  },
  computed: {
    fields () {
      return (this.package.fields || [])
    }
  },
  methods: {
    save () {
      if (!this.fields.length) {
        try {
          let model = JSON.parse(this.codestr)
          Vue.delete(model, 'plkNoEdited')
          this.$emit('changeValue', { model })
          return
        } catch (e) {}
      }
      Vue.delete(this.model, 'plkNoEdited')
      this.$emit('changeValue', { model: this.model })
    },
    changeValue (field = '', change = {}) {
      if (field) {
        Vue.set(this, 'model', addValueInKey(Object.assign({}, this.model), field, change.value))
      }
    },
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      Vue.set(this, 'model', this.initValue || {})
      Vue.set(this, 'codestr', JSON.stringify(this.model, null, 2))
      this.loadPackage()
    },
    getInstance (type = '') {
      return this.instances[this.$servicesPLK.component.normalizeType(type)]
    },
    async loadPackage () {
      if (this.type) {
        const loadedComponent = await this.$servicesPLK.component.loadComponent(this.type)
        if (loadedComponent.type === TYPE_INTERNAL_OBJECT) {
          Vue.set(this, 'package', loadedComponent.component.options.methods.getPackage())
        } else if (loadedComponent.type === TYPE_EXTERNAL_OBJECT) {
          Vue.set(this, 'package', loadedComponent.component.methods.getPackage())
        }
      }
    },
    loadComponentsByTypes () {
      this.fields.forEach(param => {
        this.loadComponent(param.type)
      })
    },
    loadComponent (type = '') {
      return new Promise((resolve, reject) => {
        const typeNormalized = this.$servicesPLK.component.normalizeType(type)
        if (!this.instances[typeNormalized]) {
          const loadComponent = () => import(`@/components/creator/configuration/types/${typeNormalized}/Index.vue`)
          loadComponent().then(componentLoaded => {
            Vue.set(this.instances, typeNormalized, componentLoaded.default)
          }).catch(e => {
            console.error(e)
            this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: `error.notfound: ${type}` })
          })
        }
      })
      /* console.log(type)
      const typeNormalized = this.$servicesPLK.component.normalizeType(type)
      console.log(typeNormalized)
      if (this.instances[typeNormalized]) {
        return
      }
      try {
        const loadComponent = () => import(`@/components/creator/configuration/types/${typeNormalized}/Index.vue`)
        const componentLoaded = await loadComponent()
        Vue.set(this.instances, typeNormalized, componentLoaded.default)
      } catch (e) {
        console.error(e)
        this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: `error.notfound: ${type}` })
      } */
    },
    addDefaultVars () {
      if (this.initValue) {
        Vue.set(this, 'defaultValues', getHashKeyValue(this.initValue))
      }
    }
  },
  watch: {
    type () {
      this.loadPackage()
    },
    package () {
      this.loadComponentsByTypes()
      this.addDefaultVars()
    },
    initValue () {
      Vue.set(this, 'model', this.initValue || {})
      Vue.set(this, 'codestr', JSON.stringify(this.model, null, 2))
    }
  }
}
</script>

<style scoped lang="scss">
.u-full-width {
  resize: vertical;
  min-height: 50vh;
}
</style>
